var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-reservation-main" }, [
    _c(
      "div",
      { staticClass: "c-reservation-main__select" },
      [_c("ReservationSelect")],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "c-reservation-main__product" },
      [_c("ReservationProduct")],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "c-reservation-main__form" },
      [_c("ReservationForm")],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "c-reservation-main__summary" },
      [_c("ReservationSummary")],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }